// extracted by mini-css-extract-plugin
export default {"wrap":"AdminPage_wrap__llEmZ"};